module.exports = __webpack_public_path__ + "static/media/40-1.ab936d21.mp3";